export class Region {
    id: number;
    libelle: string;
}
export class TypeStructure {
    id: number;
    libelle: string;
    constructor(){

    }
}
export class StatutJuridique {
    id: number;
    libelle: string;
}

export class Prefecture {
    id: number;
    libelle: string;
    id_region: number;
}

export class Commune {
    id: number;
    libelle: string;
    id_prefecture: number;
}

export class Canton {
    id: number;
    libelle: string;
    id_commune: number;
}

export class Specialite {
    id: number;
    libelle: string;
}
export class TypeDiplome {
    id: number;
    libelle: string;
}
export class Domaine {
    id: number;
    libelle: string;
}

export class TypePiece {
    id: number
    libelle: string
}



export class Pays {
    id: number
    libelle: string
    nationalite: string
    code_iso: string
}

export class Offre {
    id: number
    intitule: string
    description: string
    typeVn: string
    // urlFichier: any
    idDomaine: number
    experience_requise: boolean
    dateDebut: string
    dateFin: string
    created_at?: string
    updated_at?: string
    domaine?: Domaine
    offre_file?: OffreFile
    urlFile:string;

}
export class OffreFile {
    id: number
    url: string=''
    type: string
    extension: string
    offre_id: number
    created_at: string
    updated_at: string
}
export interface Pagination {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
    from: number;
    to: number;
}

export interface PaginatedResponse<T> {
    success: boolean;
    message: string;
    data: T[];
    pagination: Pagination;
    code: number;
}

export class GeneralResponse {
    success = false;
    message = "";
    data: any;
    pagination?: Pagination;
    code = '';
}
